import { connect, useSelector } from "react-redux";
import {
  CButton,
  CButtonGroup,
  CCol, CForm,
  CFormInput,
  CFormSelect,
  CInputGroup,
  CInputGroupText,
  CRow
} from "@coreui/react";
import { useEffect, useState } from "react";
import * as api from "../../../api/api";
import { selectedActions } from "../../../redux-store/actions/selected";
import { storeActions } from "../../../redux-store/actions/store";

const StoreListWhere = (props) => {
  const { user } = useSelector((props) => props.account);
  const [company, setCompany] = useState([{ cmpCd: "", cmpNm: "전체" }]);
  const [brand, setBrand] = useState([{ brandCd: "", brandNm: "전체" }]);
  const [store, setStore] = useState([{ storeCd: "", storeNm: "전체" }]);
  const [searchStore, setSearchStore] = useState("");

  useEffect(() => {
    getCompany();
  }, []);

  const getCompany = async () => {
    if (user.cmpCd !== null) {
      const { data: result } = await api.getCompany(user.cmpCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setCompany([responseBody]);
        props.onSelect(user.cmpCd, "C");
        props.setSelectCmpCd(user.cmpCd);
        getBrand(user.cmpCd);
      }
    } else {
      const params = {
        userId: user.userId
      }
      const { data: result } = await api.getCompanyList(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setCompany([{ cmpCd: "", cmpNm: "전체" }]);
        setCompany((state) => state.concat(responseBody));

        console.log(">>>>>> selected cmp : ", props.selected.cmpCd);
      }
    }
  };

  const getBrand = async (cmpCd) => {
    if (user.brandCd !== null) {
      const { data: result } = await api.getBrand(user.cmpCd, user.brandCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        props.onSelect(user.brandCd, "B");
        props.setSelectBrandCd(user.brandCd);
        setBrand([responseBody]);

        getStore(user.cmpCd, user.brandCd);
      }
    } else {
      const { data: result } = await api.getBrandList(cmpCd);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setBrand([{ brandCd: "", brandNm: "전체" }]);
        setBrand((state) => state.concat(responseBody));

        if (props.selected.brandCd) {
          getStore(props.selected.cmpCd, props.selected.brandCd);
        }
      }
    }
  };

  const getStore = async (cmpCd, brandCd) => {
    if (user.storeCd !== null) {
      const params = {
        cmpCd: user.cmpCd,
        brandCd: user.brandCd,
        storeCd: user.storeCd,
        manageDiv: "0",
        userId: user.userId
      };

      const { data: result } = await api.getStoreWhere(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        if (responseBody != null) {
          // 성공
          props.onSelect(user.storeCd, "S");
          props.setSelectStoreCd(user.storeCd);
          setStore(responseBody);
        }
      }
    }
    else {
      const params = {
        cmpCd: cmpCd,
        brandCd: brandCd,
        manageDiv: "0",
        userId: user.userId
      };

      const { data: result } = await api.getStoreWhere(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        if (responseBody != null) {
          // 성공
          setStore([{ storeCd: "", storeNm: "전체" }]);
          setStore((state) => state.concat(responseBody));
        }
      }
    }
  };

  const handleSelect = (e, value) => {
    if (value === "C") {
      props.onSelect(e.target.value, "C");
      props.setSelectCmpCd(e.target.value);
      setBrand([{ brandCd: "", brandNm: "전체" }]);
      getBrand(e.target.value);
    } else if (value === "B") {
      props.onSelect(e.target.value, "B");
      props.setSelectBrandCd(e.target.value);
      getStore(props.selected.cmpCd, e.target.value);
    } else if (value === "S") {
      props.onSelect(e.target.value, "S");
      props.setSelectStoreCd(e.target.value);
    }
  };

  return (
      <>
        <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
          <CCol xs={12}>
              <CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
                <CInputGroupText style={{ width: 80 }}>운영사</CInputGroupText>
                <CFormSelect id="company"
                             value={user.cmpCd ? user.cmpCd : props.selected.cmpCd}
                             onChange={(e) => handleSelect(e, "C")}>
                  {company.map((item, index) => {
                    return (
                        <option key={index} value={item.cmpCd}>{item.cmpNm}</option>
                    );
                  })}
                </CFormSelect>
              </CInputGroup>
          </CCol>
          <CCol xs={12}>
              <CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
                <CInputGroupText style={{ width: 80 }}>휴게소</CInputGroupText>
                <CFormSelect id="brand"
                             value={user.brandCd ? user.brandCd : props.selected.brandCd}
                             onChange={(e) => handleSelect(e, "B")}>
                  {brand.map((item, index) => {
                    return (
                        <option key={index} value={item.brandCd}>{item.brandNm}</option>
                    );
                  })}
                </CFormSelect>
              </CInputGroup>
          </CCol>
          <CCol xs={12}>
              <CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
                <CInputGroupText style={{ width: 80 }}>매장</CInputGroupText>
                <CFormSelect id="store"
                             value={user.storeCd ? user.storeCd : props.selected.storeCd}
                             onChange={(e) => handleSelect(e, "S")}>
                  {store.map((item, index) => {
                    return (
                        <option key={index} value={item.storeCd}>{item.storeNm}</option>
                    );
                  })}
                </CFormSelect>
              </CInputGroup>
          </CCol>
        </CForm>
      </>
);
};

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
      account, store, selected
    };
  };

const mapDispatchToProps = (dispatch) => {
    return {
      setSelectCmpCd: (cmpCd) => {
        dispatch(selectedActions.setSelectCmpCd(cmpCd));
      },
      setSelectBrandCd: (brandCd) => {
        dispatch(selectedActions.setSelectBrandCd(brandCd));
      },
      setSelectStoreCd: (storeCd) => {
        dispatch(selectedActions.setSelectStoreCd(storeCd));
      },
      setStore: (store) => {
        dispatch(storeActions.setStore(store));
      }
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(StoreListWhere);

